export const pains: string[] = [
  'There are two or three abandoned planners in a drawer. Beautiful ones. Barely used.',
  'It worked for two weeks. Then one sick day, and the whole thing quietly collapsed.',
  'Everyone’s schedule lives in your head — and that is exactly the problem.',
  'You’re keeping every worksheet, every craft, every coloring page, because you’re not sure what counts.',
  'Sunday night you’re already bracing for Monday, because you know the plan won’t survive till Wednesday.',
  'You copied another family’s whole system, and a year later you were struggling again — their homeschool was never yours.',
  'You’re running two full-time jobs at once, the house and the teaching, and you still feel behind on both.',
  'You call yourself the unorganized one, while single-handedly running an operation nobody else could run.',
]
